<template>
  <div class="marketing-block home hero-block">
    <div class="hero-panel panel">
      <div class="panel-half">
        <img :src="heroImage" class="show" @load="imageLoaded" alt="SiteBlocks Overview"/>
      </div>
      <div class="panel-half">
        <div class="padding">
          <div class="hero-logo-container">
            <img :src="siteblocksBrandImage" class="siteblocks-brand-image" alt="Siteblocks By Bravenet" />
            <img :src="braveAIBrandImage" class="braveai-brand-image" alt="BraveAI Powered" />
          </div>
          <h1 class="title">
            <span v-html="$t('home.HERO_PANEL_HEADING')"></span>
          </h1>
          <p v-html="$t('home.HERO_PANEL_BODY')"></p>
          <div><md-button to="/sitebuilder" class="md-raised md-primary">{{$t('home.HERO_PANEL_CTA')}}</md-button></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Typed from 'typed.js'
export default {
  mounted() {
    this.ready = true
    if (window.navigator.userAgent !== 'PRERENDER') {
      // Stuff here
    }
  },
  data: () => {
    let heroImage = require(`assets/img/home/hero-cycle/hero-image-1.png`)
    let siteblocksBrandImage = require(`assets/img/shared/siteblocks_logo.png`)
    let braveAIBrandImage = require(`assets/img/shared/braveai_powered-1.png`)
    return {
      heroImage,
      siteblocksBrandImage,
      braveAIBrandImage,
      typedTitle: true,
      ready: false,
      title: '<div/>'
    }
  },
  methods: {
    imageLoaded() {
      this.currentHeroImage = this.heroImageHiRes; // switch to high-res image
    }
  },
  props: [
    'view',
    'hasCTA',
    'clickHandler',
    'href',
  ]
}
</script>



// WEBPACK FOOTER //
// apps/www.bravenet.com/src/components/home/hero-panel.vue